<template>
  <div class="plan-player-component"
       @click="handleClickBtn"
  >
    <player-style :playing="playing"
                  :duration="duration"
                  :type="type"
    />
  </div>
</template>

<script>
  import PlayerStyle from '@/components/TrainingPlayer/PlayerStyle';

  export default {
    name: 'TrainingWxVoicePlayer',
    components: {
      PlayerStyle,
    },
    data() {
      return {
        playing: false,
        disabled: false,
      };
    },
    props: {
      localId: {
        type: String,
        required: true,
      },
      duration: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        default: 'voice',
        validator(val) {
          return ['audio', 'voice'].includes(val);
        },
      },
    },
    methods: {
      handleVoiceStop() {
        this.playing = false;
        this.disabled = false;
        this.$emit('stop', this.localId);
      },
      async listenVoiceEnd() {
        await this.$wechat.onVoicePlayEnd();
        this.handleVoiceStop();
      },
      async handleClickBtn() {
        if (this.disabled) return;
        // 禁止快速点击
        this.disabled = true;

        if (!this.playing) {
          await this.$wechat.playVoice(this.localId);
          this.listenVoiceEnd();
          this.playing = true;
          this.disabled = false;
          return;
        }

        await this.$wechat.pauseVoice(this.localId);
        this.handleVoiceStop();
      },
    },
  };
</script>
